import { all, call, put, takeLatest, select } from "redux-saga/effects"
import API from "../../helpers/sagaApi/sagaApi"
import Actions, { SagaPaymentTypes } from "./sagaPaymentRedux"
import AppConfig from "../../configs/AppConfig"
import { getJwtToken } from "../sagaAuth/sagaAuthSaga"
import { IpaymentRequest1, IPayment2 } from "./IPayment"
import { FormattedMessage } from "react-intl"
import { currentLanguageRfc3066Fnc } from "../languageSwitcher/languageSwitcherSaga"

export function* requestCallPaymentGateway(action) {
  const tag = "[REQUEST_CALL_PAYMENT_GATEWAY]"
  try {
    // step 1: perform input validation
    const jwtToken = yield getJwtToken()
    if (jwtToken) {
      // step 2 : validation passed..
      const response1 = yield call(
        API.requestCheckBookingPrice,
        jwtToken,
        action.userId,
        action.bookingId
      )
      // console.log("action => ", action)

      if (response1.status === 200 && response1.data.statusCode === 200) {
        if (AppConfig.isDevelopment) {
          console.log(
            `${tag} requestCheckBookingPrice response :`,
            response1.data.result
          )
        }
        const tokenRequest: IpaymentRequest1 = {
          card: action.card,
          rememberCard: false
        }
        const response2 = yield call(
          API.requestGetPaymentToken,
          response1.data.result.appKey,
          tokenRequest
        )
        if (response2.status === 200 && response2.data.resultCode === "00") {
          // console.log("response2 => ", response2)
          // console.log("action => ", action)
          const culture = yield select(currentLanguageRfc3066Fnc)
          const payment2: IPayment2 = {
            amount: +action.amount,
            backgroundUrl: `${AppConfig.sagaUrl}/GBPay/Backdata`,
            responseUrl: `${AppConfig.baseUrl}/${culture}/thankyou`,
            customerEmail: response1.data.result.user.userName,
            customerName:
              response1.data.result.user.firstName +
              " " +
              response1.data.result.user.lastName,
            card: {
              token: response2.data.card.token
            },
            detail:
              response1.data.result.booking.startPoint +
              " - " +
              response1.data.result.booking.destination,
            merchantDefined1: action.userId,
            merchantDefined2: response1.data.result.booking.bookingNo,
            otp: "Y",
            referenceNo: action.bookingId,
            merchantDefined3: "",
            merchantDefined4: "",
            merchantDefined5: ""
          }
          const response3 = yield call(
            API.requestChargePayment,
            response1.data.result.app2Key,
            payment2
          )
          if (response3.status === 200 && response3.data.resultCode === "00") {
            // console.log("response3 => ", response3)
            yield put(
              Actions.callPaymentGatewaySuccess(response3.data.gbpReferenceNo)
            )
            // const data = new FormData()
            // data.append("gbpReferenceNo", response3.data.gbpReferenceNo)
            // data.append("publicKey", "tQzVSZMhCdSOegyxWUEzzM5av9duXWHs")

            // const response4 = yield call(API.request3DSecure, data)
            // if (response4.status === 200) {
            //   console.log("response4 => ", response4)
            // } else {
            //   throw new Error(response3.data.error)
            // }
          } else {
            alert(
              "Transaction Error! Status Code => " + response3.data.resultCode
            )

            throw new Error(response3.data.error)
          }
        } else {
          alert(
            "Transaction Error! Status Code => " + response2.data.resultCode
          )
          throw new Error(response2.data.error)
        }
      } else {
        throw new Error(response1.data.error)
      }
    } else {
      throw new Error("xx.yyInvalidInput") // <-- fix me
    }
  } catch (e) {
    console.warn(`${tag} requestCallPaymentGateway failed with error :`, e)
    const message = e.message ? e.message : "Failed"
    yield put(Actions.callPaymentGatewayFailure(message))
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(
      SagaPaymentTypes.REQUEST_CALL_PAYMENT_GATEWAY,
      requestCallPaymentGateway
    )
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagaPayment/sagaPaymentSaga.ts